module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('task_log')))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Status"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "btn-toggle"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm active",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(-1, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list fa-2x text-info"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(3, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-headphones fa-2x text-primary"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(4, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ambulance fa-2x text-green"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(5, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-medkit fa-2x text-danger"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filter(6, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-md fa-2x text-warning"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body chat id-chat-box"
  }, _vm._l((_vm.tasks), function(task) {
    return _c('div', {
      key: task.id,
      staticClass: "item"
    }, [_c('img', {
      staticClass: "online",
      attrs: {
        "src": require("admin-lte/dist/img/user4-128x128.jpg"),
        "alt": "user image"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "message"
    }, [_c('small', {
      staticClass: "text-muted pull-right"
    }, [_c('i', {
      staticClass: "fa fa-clock-o"
    }), _vm._v(" " + _vm._s(_vm.moment(task.insertTime).startOf('hour').fromNow()))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.showUser(task.enterBy)
        }
      }
    }, [_vm._v(_vm._s(task.enterBy))]), _vm._v("   - > "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.showUser(task.contactNumber)
        }
      }
    }, [_vm._v(_vm._s(task.contactNumber))]), _vm._v(" "), _c('br'), _vm._v("\n      \n        " + _vm._s(_vm.$t('tasklist')[[task.taskGroup - 3]]) + "\n       \n      ")]), _vm._v(" "), (task.taskGroup == 6) ? _c('div', {
      staticClass: "border border-warning"
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('medicine_list')))]), _vm._v(" "), _c('table', {
      staticClass: "table table-striped"
    }, [_c('tbody', _vm._l((task.medicines), function(med) {
      return _c('tr', {
        key: med.id,
        staticClass: "filename"
      }, [_c('td', [_vm._v("\n               " + _vm._s(med.name)), _c('br'), _vm._v("\n               " + _vm._s(_vm.$t('medicineType')[[med.productType]]) + "  " + _vm._s(_vm.$t('medicineGroups')[[med.groupName]]) + "\n              \n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('quantityData')[[med.quantity]]) + " "), (med.productType == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('spoon')))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('durationData')[[med.duration]]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('beforeAftermealData')[[med.beforeAfterMeal]]))])])
    }), 0)])]) : _c('div', [_c('table', {
      staticClass: "table table-striped"
    }, [_c('tbody', _vm._l((task.taskLog), function(log) {
      return _c('tr', {
        key: log.id,
        staticClass: "filename"
      }, [_c('td', [(task.taskGroup == 3) ? _c('span', [_vm._v(_vm._s(_vm.$t('consultantTasks')[[log.task]]))]) : _vm._e(), _vm._v(" "), (task.taskGroup == 4) ? _c('span', [_vm._v(_vm._s(_vm.$t('ambulanceTasks')[[log.task]]))]) : _vm._e(), _vm._v(" "), (task.taskGroup == 5) ? _c('span', [_vm._v(_vm._s(_vm.$t('deliveryTasks')[[log.task]]))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.updateBy))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.updateTime))])])
    }), 0)])]), _vm._v(" "), _c('hr', {
      staticClass: "text-success"
    })])
  }), 0), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Type message..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32f64f71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VAChatBox.vue
// module id = 705
// module chunks = 1